import api from '@/api'

export default {
  getPhotoUrl(address: string): Promise<string> {
        return api.get({
            url: `/Hr/Photo/api/get?email=${address}`
    })
  },

  getPhotoUrlByCodes(codes: string[]): Promise<orgmap.EmployeePhoto[]> {
    return api.post({
        url: '/Hr/Photo/api/byCodes',
        data: codes,
    })
  },

  getUser(email: string): Promise<orgmap.TUser> {
    return api.get({
      url: `/Hr/person/api/get`,
      params: {
        email,
      },
    })
  },

  getUserByPersonCode(personCode: string): Promise<orgmap.TUser> {
    return api.get({
      url: `/Hr/department/api/person`,
      params: {
        personCode,
      },
    })
  },
}
